var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React from 'react';
import { modalFakeLine, modalSkeletonBody, modalSkeletonHeader, modalSkeletonLoader, modalSkeletonParagraph } from './skeleton-css';
export var defaultParagraphNumber = 3;
var FakeContentLine = function () { return (React.createElement("i", { className: modalFakeLine })); };
/**
 * Skeleton header to put inside a popin.
 */
export var ModalHeaderSkeleton = function () { return (React.createElement("h1", { className: modalSkeletonHeader },
    React.createElement(FakeContentLine, null),
    React.createElement(FakeContentLine, null),
    React.createElement("i", { className: modalSkeletonLoader }))); };
var defaultNumberOfLines = 4;
var FakeContentParagraph = function () { return (React.createElement("div", { className: modalSkeletonParagraph }, __spreadArray([], __read(Array(defaultNumberOfLines).keys())).map(function (index) { return React.createElement(FakeContentLine, { key: index }); }))); };
/**
 * Skeleton content to put inside a popin.
 */
export var ModalContentSkeleton = function (_a) {
    var _b = _a.paragraphNumber, paragraphNumber = _b === void 0 ? defaultParagraphNumber : _b;
    return (React.createElement("section", { className: modalSkeletonBody }, __spreadArray([], __read(Array(paragraphNumber).keys())).map(function (index) { return (React.createElement(FakeContentParagraph, { key: index })); })));
};
